import { Injectable } from '@angular/core';
import { HttpService } from '@g99-product-web-ui/shared-service';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';

import { NotificationReadStatus } from '../constants/notification.constant';
import {
  INotificationDto,
  IPageResponse,
} from '../interfaces/notification.interface';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private readonly _httpService: HttpService) {}

  public getNotifications(
    pageIndex: number,
    pageSize: number,
    status?: NotificationReadStatus,
    recipientId?: number
  ) {
    // Build query string in the same style as the reference service
    let apiUrl = API_ENDPOINTS.NOTIFICATION_ENDPOINTS.base;
    const query = new URLSearchParams();

    query.set('page', String(pageIndex));
    query.set('size', String(pageSize));

    if (status) {
      query.set('status', status);
    }
    if (recipientId != null) {
      query.set('recipientId', String(recipientId));
    }

    const qs = query.toString();
    if (qs) {
      apiUrl += `?${qs}`;
    }

    return this._httpService.get<IPageResponse<INotificationDto>>(apiUrl);
  }

  public markNotificationRead(notificationId: number) {
    const apiUrl =
      API_ENDPOINTS.NOTIFICATION_ENDPOINTS.markRead(notificationId);
    return this._httpService.patch<void, object>(apiUrl, {
      status: 'READ',
    });
  }

  public markAllNotificationsRead(recipientId: number) {
    const apiUrl =
      API_ENDPOINTS.NOTIFICATION_ENDPOINTS.markAllRead(recipientId);
    return this._httpService.patch<void, object>(apiUrl, {});
  }
}
